module.exports = __webpack_public_path__ + "static/media/error.16a5c916.svg";